import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { paths } from '../../paths'

export const budgetlistinipage: JSX.Element[] = [
  <Route
    component={lazy(async () => {
      const { BudgetListiniPage } = await import(
        /* webpackChunkName: "BudgetListiniPage" */ '../../../components/pages/private/BudgetListiniPage'
      )
      return {
        default: BudgetListiniPage,
      }
    })}
    exact
    key={paths.budgetListini}
    path={paths.budgetListini}
  />,
]
